import Vue from 'vue'
import apiService from '@/utils/api-client'
import config from '@/utils/appConfig'
import analytics from '@/store/modules/analytics'
import { checkPermissions, featureAccess } from '@/utils/accesses'
import { formatUrlForAuthImg } from '@/utils/url-formatter'
import { fetchExternalGraph, resolveCaseGraph } from '@/utils/visual-case-load'

export default {
  // eslint-disable-next-line no-unused-vars
  getAllcases: async function ({commit}, {
    title = undefined,
    from = undefined,
    to = undefined,
    coin = undefined,
    skip = undefined,
    count = undefined,
    archived = undefined,
    search = undefined,
  }) {
    try {
      let data;
      data = apiService.get('explorer/visualCases', {params: {from, to, title, archived, skip, count, blockchain: coin, search}, baseURL: config.VUE_APP_API_USERS_URL });
      // commit('ADD_HISTORY_ENTRY', { path: `api/tx/visualCases`})
      return data
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  getCaseById: async function ({ commit }, id) {
    try {
      let data = await apiService.get(`explorer/visualCase/${id}`, { baseURL: config.VUE_APP_API_USERS_URL })
      if (data?.data) {
        // GLBA-13207: externalized cases carry graphUrl instead of the inline graph
        try {
          data.data.graph = await resolveCaseGraph(data.data, url => fetchExternalGraph(url, u => apiService.get(u)))
        } catch (error) {
          console.error('Case graph load error:', error)
          Vue.toasted.global.error({ message: 'Failed to load case graph' })
        }
      }
      return data
    } catch ({ response }) {
      if (response.data.code == '403') {
        commit('analytics/SET_MODAL_PRIVATE_CASE', response.data, { root: true })
      }
    }
  },
  // GLBA-13207: an externalized case keeps its preview behind `imageUrl`, but create/update
  // only accept the inline base64 `image` (the api externalizes it itself), so copying such
  // a case has to pull the preview back down and inline it. Resolves to undefined on any
  // failure — a copy without a thumbnail is far better than a failed copy.
  async fetchCasePreview(ctx, imageUrl) {
    const url = formatUrlForAuthImg(imageUrl)

    if (!url) return undefined

    try {
      const response = await fetch(url)

      if (!response.ok) return undefined

      const blob = await response.blob()

      return await new Promise(resolve => {
        const reader = new FileReader()
        // createCase expects raw base64, the way cy.png({ output: 'base64' }) returns it,
        // so the `data:image/png;base64,` prefix has to come off
        reader.onloadend = () => resolve(String(reader.result).split(',')[1] || undefined)
        reader.onerror = () => resolve(undefined)
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      console.error('Case preview load error:', error)
      return undefined
    }
  },
  // eslint-disable-next-line no-unused-vars
  async createCase(ctx, { search, graph, title, image, blockchain, isPrivate }) {
    const payload = { search, graph, title, image, blockchain }
    if (typeof isPrivate === 'boolean' && checkPermissions(ctx.rootGetters['user/permissions'], ['trace_cases_modify'])) {
      payload.private = isPrivate
    }
    try {
      const data = apiService.post('explorer/visualCase', payload, { baseURL: config.VUE_APP_API_USERS_URL })
        return data
    } catch (error) {
        console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async visualCaseUpdates({ commit }, { addresses, mode, caseId, baseURL = analytics.state.coinData.baseUrl }) {
    try {
      return apiService.post('explorer/visualCaseUpdates', { addresses, mode, caseId }, { baseURL })
    } catch (error) {
        console.error(error)
    }
  },

  // eslint-disable-next-line no-unused-vars
  async deleteCase({ commit }, { caseIds }) {
    try {
      const data = apiService.delete(`explorer/visualCase`, { data: { ids: caseIds }, baseURL: config.VUE_APP_API_USERS_URL })
      return data
    } catch (error) {
      console.error(error)
    }
  },

  editCase(ctx, { id, title, image, graph, isPrivate, description, publicCase, blockchain }) {
    const payload = { id, title, image, graph, description, publicCase, blockchain }
    if (
      typeof isPrivate === 'boolean' &&
      featureAccess('PERMISSION_MANAGER') &&
      checkPermissions(ctx.rootGetters['user/permissions'], ['trace_cases_modify'])
    ) {
      payload.private = isPrivate
    }
    return apiService.patch(`explorer/visualCase`, payload, { baseURL: config.VUE_APP_API_USERS_URL })
  },

  // eslint-disable-next-line no-unused-vars
  casesToArchive({ commit }, { ids, status }) {
    return apiService.put('/explorer/visualCase', { ids, status: String(status) }, { baseURL: config.VUE_APP_API_USERS_URL })
  },
}
